module.exports = __webpack_public_path__ + "img/heightLight.4d059ce3.png";